<template>
  <div class="is-relative">
    <b-loading v-model="loading" :is-full-page="false" />

    <div class="sticky-container-top mb-5">
      <b-tabs v-if="!loading" v-model="activeTab" class="mb-0" size="is-medium" type="is-boxed" expanded>
        <b-tab-item label="Pick"></b-tab-item>
        <b-tab-item label="Parlay"></b-tab-item>
      </b-tabs>
    </div>

    <league v-for="(league, i) in leagues"
            :league="league"
            :key="`league-${i}`"
            @picked="$emit('picked', $event)"
            @parlayPicked="handleParlayPicked"
            :parlay="isParlay" :class="`${i !== leagues.length - 1 ? 'mb-6' : ''}`" />

    <div class="sticky-container-bottom">
      <div class="buttons is-right mt-5">
        <button v-if="isParlay && hasEventsToParlay"
                @click="$emit('parlayPicked', parlayEvents)"
                class="button is-success">
          Done
        </button>
        <button @click="$emit(isParlay ? 'parlayFromScratch' : 'fromScratch')"
                class="button">
          From Scratch
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import {getBoard} from '@/utils/api';
import League from '@/components/admin/League';
/*import {BTabs, BTabItem} from 'buefy/dist/esm/tabs';*/

export default {
  components: {
    League,
    /*BTabs,
    BTabItem*/
  },
  data() {
    return {
      activeTab: 0,
      leagues: [],
      loading: true,
      parlayEvents: {}
    }
  },
  mounted() {
    getBoard()
    .then(async res => {
      if (res.ok) {
        let board = await res.json();
        this.leagues = board.activeLeagueGames;
      } else {
        let err = `${res.status} | ${res.statusText}`;
        console.log({err});
      }
    })
    .catch(err => console.error(err.message))
    .finally(() => this.loading = false);
  },
  computed: {
    isParlay: function () {
      return !!this.activeTab
    },
    hasEventsToParlay: function () {
      return Object.keys(this.parlayEvents).length;
    }
  },
  methods: {
    handleParlayPicked: function (e) {
      if (!this.parlayEvents[e.id]) {
        return this.parlayEvents = {...this.parlayEvents, [e.id]: e}
      }

      this.parlayEvents[e.id].body = e.body;
      this.parlayEvents = {...this.parlayEvents};
    }
  }
}
</script>

<style lang="scss">
//@import "~bulma/sass/utilities/all";
//@import "~bulma/sass/components/tabs";
//@import "~buefy/src/scss/utils/functions";
//@import "~buefy/src/scss/utils/variables";
//@import "~buefy/src/scss/components/tabs";
</style>